import { createTheme, responsiveFontSizes } from '@mui/material/styles';

let theme = createTheme({
  typography: {
    fontFamily: 'Manrope',
    fontSize: 16,
    h4: {
      fontWeight: 700,
      textAlign: 'left',
      marginBottom: '1rem',
    },
    h5: {
      fontWeight: 700,
      textAlign: 'left',
      color: 'inherit',
      textDecoration: 'none',
    },
    h6: {
      fontFamily: 'Orbitron',
      fontWeight: 700,
      letterSpacing: '.3rem',
      color: 'inherit',
      textDecoration: 'none',
    },
    body1: {
      color: 'inherit',
      textDecoration: 'none',
      fontSize: '1rem'
    },
    button: {
      lineHeight: 1,
      textDecoration: 'none',
      textTransform: 'none'
    },
    subtitle1: {
      textAlign: 'left',
      width: '90%'
    },
    subtitle2: {
      textAlign: 'center',
      marginBottom: "2rem"
    }
  }
});

theme = responsiveFontSizes(theme);

export default theme; 